import type {
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import { Field, Input, Select, Textarea } from "./Field";

interface BaseProps {
  label?: ReactNode;
  hint?: ReactNode;
  required?: boolean;
  className?: string;
}

type InputFieldProps = BaseProps &
  Omit<InputHTMLAttributes<HTMLInputElement>, "className"> & {
    as?: "input";
  };

type TextareaFieldProps = BaseProps &
  Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "className"> & {
    as: "textarea";
    rows?: number;
  };

type SelectFieldProps = BaseProps &
  Omit<SelectHTMLAttributes<HTMLSelectElement>, "className"> & {
    as: "select";
    children: ReactNode;
  };

type TextFieldProps = InputFieldProps | TextareaFieldProps | SelectFieldProps;

export const TextField = (props: TextFieldProps) => {
  const { label, hint, required, className, as = "input", ...rest } = props;
  return (
    <Field label={label} hint={hint} required={required} className={className}>
      {as === "input" ? (
        <Input {...(rest as InputHTMLAttributes<HTMLInputElement>)} />
      ) : as === "textarea" ? (
        <Textarea {...(rest as TextareaHTMLAttributes<HTMLTextAreaElement>)} />
      ) : (
        <Select {...(rest as SelectHTMLAttributes<HTMLSelectElement>)}>
          {(rest as SelectFieldProps).children}
        </Select>
      )}
    </Field>
  );
};
